import { message } from 'antd';
import { isBoolean } from 'lodash-es';
import { requestDownloadPathCache } from 'services/cache';
import chatttSDK from 'services/chattt';
import { tolgee } from 'services/i18n/tolgee';
import { logger } from 'services/logger';

export const browserDownload = (url: string, name?: string, self = false) => {
  const a = document.createElement('a');
  a.setAttribute('href', url);
  if (name) {
    a.setAttribute('download', name);
  }
  a.setAttribute('target', self ? '_self' : '_blank');
  a.style.position = 'absolute';
  a.style.left = '-99999px';
  a.style.top = '-99999px';
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
};
const invalidCharacterInWindowsFilename = ['\\', '/', ':', '*', '?', '"', '<', '>', '|'];
const transferFilenameSpecialCharacter = (filename: string): string => {
  return invalidCharacterInWindowsFilename.reduce(
    (str, char) => str.replaceAll(char, '_'),
    filename,
  );
};

/**
 * 统一编码 URL 路径部分，兼容已编码和未编码的情况
 */
const encodeURL = (url: string): string => {
  logger.info(`[download][encodeURL]url: ${url}`);
  try {
    const u = new URL(url);
    const pathname = encodeURI(decodeURIComponent(u.pathname));
    const output = `${u.protocol}//${u.host}${pathname}${u.search}`;
    logger.info(`[download][encodeURL]output: ${output}`);
    return output;
  } catch (error: any) {
    // 如果解码失败（可能包含无效的编码序列如 %GG），返回原 URL
    logger.error(`[download][encodeURL]url: ${url}, error: ${error?.message}`);
    return url;
  }
};

const download = async (url: string, name = '', forceBrowserDownload = false) => {
  const filename = transferFilenameSpecialCharacter(name);
  if (forceBrowserDownload || !chatttSDK?.download) {
    browserDownload(url, filename);
    return false;
  }
  if (!chatttSDK.app.getDownloadPath) {
    message.error(tolgee.t('trade.退款客户端升级'));
    return false;
  }
  const path = await chatttSDK.app.getDownloadPath();
  if (!path) {
    return false;
  }
  /**
   * NOTE: url 需要由后端进行encode，否则会出现下载失败的情况
   */
  const response = await chatttSDK.download(encodeURL(url), path, {
    filename,
    extract: false,
  });
  return isBoolean(response) ? response : response.success;
};

export const checkDownloadPath = async () => {
  if (!chatttSDK?.download) {
    return true;
  }
  if (!chatttSDK.app.getDownloadPath) {
    message.error(tolgee.t('trade.退款客户端升级'));
    return false;
  }
  const force = requestDownloadPathCache.get() ? true : undefined;
  const path = await chatttSDK.app.getDownloadPath(force);
  return Boolean(path);
};

export default download;
